import React from 'react';

import './App.css';

const User = (props) => {
  const { top, left, id } = props;
  return (
    <>
      <div
        id={id}
        title={"this is you!"}
        style={{ position: 'absolute', transform: `translate(${left}px, ${top}px)` }}
        className="user"
      >You</div>
    </>
  )
}

export default User;
